import React, { useRef } from "react";

import Header from "@/components/Header";
import Hero from "@/components/Hero";
import WhyThisMatters from "@/components/WhyThisMatters";
import Discover from "@/components/Discover";
import WhoFor from "@/components/WhoFor";
import Host from "@/components/Host";
import FinalCTA from "@/components/FinalCTA";
import RegistrationForm from "@/components/RegistrationForm";
import Footer from "@/components/Footer";

const Landing = () => {
  const registerRef = useRef(null);

  const scrollToRegister = () => {
    const el = document.getElementById("register");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="App" data-testid="app-root">
      <Header onRegister={scrollToRegister} />
      <main>
        <Hero onRegister={scrollToRegister} />
        <WhyThisMatters />
        <Discover />
        <WhoFor />
        <Host />
        <FinalCTA onRegister={scrollToRegister} />
        <RegistrationForm ref={registerRef} />
      </main>
      <Footer />
    </div>
  );
};

export default Landing;
